// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"181":"36a6181687a5d4d6","362":"587469ca24a50886"}[chunkId] + ".js";
};